import Cookies from './Cookies';

const getStorageAPIValue = function (storageName) {
    if (!storageName) return;
    const prefix = storageName.substring(0, 9);
    if (prefix === 'livechat_') {
        storageName = storageName.substring(prefix.length, storageName.length);
        return (
            ApexChat.storageAPI.Get(`apexchat_${storageName}`) ||
            ApexChat.storageAPI.Get(`livechat_${storageName}`)
        );
    }
    return Cookies.get(storageName);
};
export default getStorageAPIValue;
